import { render, staticRenderFns } from "./TestItem.template.vue?vue&type=template&id=3fb96f16&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb96f16",
  null
  
)

export default component.exports